<section class="page-head">
  <div class="container h-100">
    <div class="row align-items-center">
      <div class="col-md-6">
        <h1>{{lang.LocationDetails}}
          <span>{{lang.VisitOurSites}}</span>
        </h1>
      </div>
    </div>
  </div>
  <img src="assets/images/locations.jpg" alt="{{lang.LocationDetails}}">
</section>
<div class="sub-nav">
  <ul>
    <li>
      <a [routerLink]="[lang.LocationsUrl]" class="active">{{lang.OurLocation}}</a>
    </li>
    <li>
      <a [routerLink]="[lang.LocationsSearchUrl]">{{lang.LocationSearch}}</a>
    </li>
  </ul>
</div>
<section class="ptb-90">
  <div class="container">
    <div class="row">
      <div class="col-lg-5 pr-90 location-details">
        <div class="details">
          <h2>{{locationDetail.name}}</h2>
          <div class="address">
            <p *ngIf="locationDetail.address2==='' && locationDetail.address1!==''">{{locationDetail.address1}} {{locationDetail.city}}, {{locationDetail.state}} {{locationDetail.postalCode}} {{locationDetail.country}}</p>
            <p *ngIf="locationDetail.address2!==''">{{locationDetail.address1}}, {{locationDetail.address2}} {{locationDetail.city}}, {{locationDetail.state}} {{locationDetail.postalCode}} {{locationDetail.country}}</p>
            <p *ngIf="locationDetail.publicPhone2==='' && locationDetail.publicPhone1!==''"><a href="tel:{{locationDetail.publicPhone1}}"><i class="fa-solid fa-phone"></i> {{locationDetail.publicPhone1}}</a></p>
            <p *ngIf="locationDetail.publicPhone2"><a href="tel:{{locationDetail.publicPhone1}}"><i class="fa-solid fa-phone"></i> {{locationDetail.publicPhone1}}</a> | <a href="tel:{{locationDetail.publicPhone2}}">{{locationDetail.publicPhone2}}</a></p>
          </div>

          <div class="abt-info" *ngIf="locationDetail.additionalInfo">
            <h3>{{lang.AboutThisLocation}}</h3>
            <div id="AboutLocation" [innerHTML]="locationDetail.additionalInfo">
              
            </div>
          </div>
          <div class="hours" *ngIf="locationDetail.hours">
            <h3>{{lang.WorkingHours}}</h3>
            <div [innerHTML]="locationDetail.hours"></div>
          </div>
        </div>
      </div>
      <div class="col-lg-7 google_map location_details">
        <div class="position-relative">
          <a href="https://maps.google.com/maps?q=+({{locationDetail?.name}}%20[{{locationDetail?.address1}}%20{{locationDetail?.city}}%20{{locationDetail?.state}}])" rel="external" title="View on interactive map" target="_blank">
          <img
          src="https://api.mapbox.com/styles/v1/mapbox/streets-v10/static/pin-l+ec3636({{locationDetail?.mapLongitude}},{{locationDetail?.mapLatitude}})/{{locationDetail?.mapLongitude}},{{locationDetail?.mapLatitude}},12.0,0,0/600x280?access_token=pk.eyJ1Ijoic2NobndlYiIsImEiOiJjam1qb2M5MmcwaGVvM3ZwczM5M2R6NHF6In0.E-l3s573ehFSV8dy_DJAuQ"
            style="border:0; width:100%; height:auto;" allowfullscreen="" loading="lazy"
            referrerpolicy="no-referrer-when-downgrade" class="br-15"/>
          </a>
          <div class="mapbox-attribution" >
            <a href="https://www.mapbox.com/about/maps/" target="_blank">© Mapbox</a>&nbsp;
            <a href="https://www.openstreetmap.org/copyright" target="_blank">© OpenStreetMap</a>&nbsp;
            <a href="https://www.mapbox.com/map-feedback/#/{{locationDetail?.mapLongitude}}/{{locationDetail?.mapLatitude}}/13" target="_blank">{{lang.Improvethismap}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
